<ng-container *transloco="let t">
    @if (inputForm && formHelper) {
    <div [formGroup]="inputForm">
        <ng-template #fieldControl let-field="field">
            @switch (field.controlType) {
            @case ('text') {
            <app-input [formControlName]="field.key" [label]="field.labelKey"/>
            }
            @case ('number') {
            <app-input type="number" [formControlName]="field.key" [label]="field.labelKey"/>
            }
            @case ('tel') {
            <app-tel-input [formControlName]="field.key"
                           [label]="t(field.labelKey)"
                           [numberPlaceholder]="t(field.labelKey)"/>
            }
            @case ('select') {
            <app-select [formControlName]="field.key" [items]="field.items ?? []"
                        [labelKey]="field.itemLabelKey ?? 'name'" [valueKey]="field.itemValueKey ?? 'id'"
                        [labelKeyPrefix]="field.itemLabelKeyPrefix ?? ''"
                        [label]="field.labelKey"/>
            }
            @case ('date') {
            <app-date-time-input [formControlName]="field.key" [displayTime]="false"
                                 [openDate]="field.openDate" [label]="t(field.labelKey)"
                                 [allowOnlyYearSelection]="field.allowOnlyYearSelection ?? false"
                                 [minDate]="field.minDate" [maxDate]="field.maxDate"/>
            }
            }
        </ng-template>
        <div class="fields-row">
            @for (field of formHelper | visibleFields; track field.key) {
            <div class="field-item">
                <ng-container *ngTemplateOutlet="fieldControl; context: { field: field }"/>
            </div>
            }
        </div>

        <div class="fields-row">
            @for (field of formHelper | visibleCustomFields; track field.id) {
            <div class="field-item">
                <app-field-config-value-input [inputForm]="formHelper | customFieldValuesFormGroup:inputForm" [fieldConfig]="field"
                                          [fieldKey]="field.id?.toString() ?? ''"/>
            </div>
            }
        </div>


    </div>
    }


</ng-container>